import React from 'react';
import { useClinic } from '@/contexts/ClinicContext';
import { EmrCalendar } from '@/components/emr';

const EmrCalendarPage: React.FC = () => {
  const { clinic } = useClinic();

  if (!clinic) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-muted-foreground">Loading clinic...</p>
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-64px)]">
      <EmrCalendar clinicId={clinic.id} />
    </div>
  );
};

export default EmrCalendarPage;
